<div class="table-scroll-wrapper">
  @if (!isScrollAtStart) {
    <lib-elux-icon
      class="btn-scroll btn-scroll-left"
      (click)="scrollHorizontally('left')"
      [icon]="'Upload.svg'"
      size="24"
      sizeType="px"
      [color]="'#5B6A78'"
    />
  }

  <div #scrollWrapper class="table-scroll" (scroll)="onTableScroll($event)">
    <table class="table-custom">
      <tr class="table-head">
        <th
          *ngFor="let head of headers"
          [class]="head.type + ' ' + (head.align ? head.align : 'left') + ' ' + (isScrollAtEnd ? '' : 'column-fixed')"
          [style.width]="getHeaderWidth(head)"
        >
          <div class="d-row align-items-center">
            <span class="subtitle-1">{{ head.name }}</span>
            @if (head.info) {
              <a
                class="c-pointer ms-2"
                [id]="'tooltip_' + head.key"
                (mouseenter)="mouseEnterTooltip(head)"
                (mouseleave)="mouseLeaveTooltip()"
              >
                <lib-elux-icon [icon]="'Info.svg'" size="20" sizeType="px" />
              </a>
            }
          </div>
        </th>
      </tr>

      <tbody
        *ngFor="let group of tableData; let g = index"
        class="group"
        cdkDropList
        (cdkDropListDropped)="drop($event, g)"
        [class.is-disabled]="activeGroupIndex !== null && activeGroupIndex !== g"
      >
        @if (group.rows.length === 0) {
          <tr>
            <td [attr.colspan]="headers.length" class="p-5 row-not-found">
              <span class="body">Nenhum item encontrado</span>
            </td>
          </tr>
        } @else {
          <tr
            *ngFor="let row of group.rows; let i = index"
            [class.row-active]="row.showAction === true"
            [class.row-new]="row.object.id == group.newId"
            cdkDrag
            (cdkDragStarted)="onDragStart(g)"
            (cdkDragEnded)="onDragEnd()"
            [cdkDragDisabled]="!hasColumnDrag()"
          >
            <td
              *ngFor="let head of headers"
              [class]="
                head.type +
                ' ' +
                (head.align ? head.align : 'left') +
                ' ' +
                (row.showAction === true ? 'row-active' : '') +
                ' ' +
                (isScrollAtEnd ? '' : 'column-fixed')
              "
            >
              @if (head.type === 'drag') {
                <div
                  cdkDragHandle
                  class="body"
                  [attr.draggable]="activeGroupIndex !== null && activeGroupIndex === g ? true : null"
                >
                  <lib-elux-icon class="drag-handle" [icon]="'More_Menu.svg'" [size]="'24'" />
                </div>
              } @else if (head.type === 'order') {
                <div class="body">{{ i + 1 }}</div>
              } @else if (head.type === 'value' || head.type === 'new-value') {
                @if (!row.object[head.key || '']) {
                  <span class="body">-</span>
                } @else {
                  <div class="d-column">
                    <span class="body text-break">{{ row.object[head.key || ''] }}</span>
                    @if (head.type === 'new-value' && row.object.id == group.newId) {
                      <div class="d-row align-items-center mt-1">
                        <lib-elux-icon class="me-1" [color]="'#011e41'" [icon]="'Stars_2.svg'" [size]="'16'" />
                        <span class="caption c-blue">Novo</span>
                      </div>
                    }
                  </div>
                }
              } @else if (head.type === 'tags') {
                @if (!row.object[head.key || ''] || row.object[head.key || ''].length === 0) {
                  <span class="body">—</span>
                } @else {
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    @for (tag of row.object[head.key || '']; track tag) {
                      <span class="product-tag caption">{{ tag }}</span>
                    }
                  </div>
                }
              } @else if (head.type === 'status') {
                <div class="body">
                  @if (head.labelBlue && row.object[head.key || ''] === head.labelBlue) {
                    <span class="span status-blue">{{ head.labelBlue }}</span>
                  } @else if (head.labelYellow && row.object[head.key || ''] === head.labelYellow) {
                    <span class="span status-yellow">{{ head.labelYellow }}</span>
                  } @else if (row.object[head.key || ''] === head.labelRed) {
                    <span class="span status-inactive">{{ head.labelRed }}</span>
                  } @else if (row.object[head.key || ''] === head.labelGreen) {
                    <span class="span status-active">{{ head.labelGreen }}</span>
                  } @else {
                    <span class="span" [ngClass]="row.object[head.key || ''] ? 'status-active' : 'status-inactive'">
                      {{ row.object[head.key || ''] ? head.labelGreen || 'Ativo' : head.labelRed || 'Inativo' }}
                    </span>
                  }
                </div>
              } @else if (head.type === 'action') {
                <div
                  class="body c-pointer"
                  [id]="'context-' + g + '-' + i"
                  (click)="row.showAction = !row.showAction"
                  (clickOutside)="row.showAction = false"
                >
                  <lib-elux-icon [icon]="'Points.svg'" [size]="'24'" />
                </div>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (!isScrollAtEnd) {
    <lib-elux-icon
      [ngClass]="getActions().length ? 'btn-scroll-right-action' : 'btn-scroll-right'"
      class="btn-scroll"
      (click)="scrollHorizontally('right')"
      [icon]="'Upload.svg'"
      size="24"
      sizeType="px"
      [color]="'#5B6A78'"
    />
  }
</div>

@if (tableData[0].totalPages && tableData[0].currentPage && tableData[0].totalPages > 1) {
  <div class="d-flex justify-content-center pt-6">
    <lib-elux-paginator
      [length]="tableData[0].totalPages"
      [current]="tableData[0].currentPage"
      (paginationEvents)="onPaginationEvent.emit($event)"
    />
  </div>
}

@if (change) {
  <div class="d-flex justify-content-end pt-7">
    <div class="col-2">
      <lib-elux-button (click)="cancel()" [content]="'Cancelar'" [type]="'text'" />
    </div>
    <div class="col-2">
      <lib-elux-button (click)="save()" [content]="'Salvar ordem'" [type]="'basic'" />
    </div>
  </div>
}

<div *ngFor="let tooltip of tooltips">
  @if (tooltip.show) {
    <app-tooltip
      (mouseenter)="tooltip.show = true"
      (mouseleave)="tooltip.show = false"
      (close)="tooltip.show = false"
      [elementRelatedName]="tooltip.key"
      [text]="tooltip.content"
    />
  }
</div>

<ng-container *ngFor="let group of tableData; let g = index">
  <ng-container *ngFor="let row of group.rows; let i = index">
    @if (row.showAction) {
      <app-context-menu [elementRelatedName]="'context-' + g + '-' + i">
        <div class="d-column">
          @for (action of getActions(); track $index) {
            @if (action === 'edit') {
              <a class="option d-row subtitle-1 p-3" [routerLink]="'edit-' + group.prefix + '/' + row.object.id">
                <lib-elux-icon [icon]="'Edit_2.svg'" [size]="'20'" />
                <span class="ms-2">Editar</span>
              </a>
            } @else if (action === 'duplicate') {
              <a
                class="option d-row subtitle-1 p-3"
                [routerLink]="'create-' + group.prefix"
                [queryParams]="{ duplicateId: row.object.id }"
              >
                <lib-elux-icon [icon]="'Copy.svg'" [size]="'20'" />
                <span class="ms-2">Duplicar</span>
              </a>
            } @else if (action === 'delete') {
              <a class="option d-row subtitle-1 p-3" (click)="deleteRow(row.object.id)">
                <lib-elux-icon [icon]="'Trash.svg'" [size]="'20'" />
                <span class="ms-2">Excluir</span>
              </a>
            }
          }
        </div>
      </app-context-menu>
    }
  </ng-container>
</ng-container>
